import { InputHTMLAttributes, useState } from 'react';
import { RegisterOptions, UseFormRegisterReturn } from 'react-hook-form';

import { ErrorType } from 'types';

import { FlagLabel } from 'components/FlagLabel';
import { Label } from 'components/Label';

import * as S from './Input.styles';
import { StyledInputProps } from './Input.styles';

type InputProps = InputHTMLAttributes<HTMLInputElement> & {
  name?: string;
  label?: string;
  register?: (name: string, options?: RegisterOptions) => UseFormRegisterReturn;
  options?: RegisterOptions;
  className?: string;
  error?: ErrorType;
  hasShowIcon?: boolean;
  hasAutoComplete?: boolean;
} & StyledInputProps;

const defaultProps: Partial<InputProps> = {
  options: {},
  error: undefined,
  scale: 's',
  label: '',
  className: '',
  motive: 'm1',
  flag: undefined,
  name: undefined,
  register: undefined,
  hasShowIcon: false,
  hasAutoComplete: true,
};

export function Input(props: InputProps): React.ReactElement {
  const {
    name,
    label,
    className,
    register,
    options,
    error,
    scale,
    motive,
    flag,
    type,
    value,
    disabled,
    onChange,
    required,
    defaultValue,
    hasShowIcon,
    hasAutoComplete,
    ...rest
  } = {
    ...defaultProps,
    ...props,
  };

  const [isShowPassword, isShowPasswordSet] = useState<boolean>();

  return (
    <S.Wrapper error={error} className={className} motive={motive}>
      {label ? (
        <Label required={required} error={error}>
          {label}
        </Label>
      ) : null}

      <S.InputWrapper withNoLabel={!label}>
        {flag && (
          <S.FlagWrapper withNoLabel={!label}>
            <FlagLabel type={flag} plain />
          </S.FlagWrapper>
        )}
        {name && register ? (
          <S.SInput
            autoComplete={!hasAutoComplete ? 'new-password' : undefined}
            type={isShowPassword ? 'text' : type || 'text'}
            flag={flag}
            withNoLabel={!label}
            {...register(name, options)}
            id={name}
            scale={scale}
            disabled={disabled}
            {...rest}
            defaultValue={defaultValue}
          />
        ) : (
          <S.SInput
            autoComplete={!hasAutoComplete ? 'new-password' : undefined}
            type={isShowPassword ? 'text' : type || 'text'}
            flag={flag}
            withNoLabel={!label}
            id={name}
            name={name}
            scale={scale}
            value={value}
            disabled={disabled}
            onChange={onChange}
            defaultValue={defaultValue}
            {...rest}
          />
        )}

        {hasShowIcon ? (
          <S.PasswordButton
            type="button"
            iconLeft={isShowPassword ? 'RiEyeLine' : 'RiEyeCloseLine'}
            onClick={() => isShowPasswordSet(!isShowPassword)}
          />
        ) : null}
      </S.InputWrapper>
    </S.Wrapper>
  );
}
